import { FaDownload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();

  const handleDownloadResume = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const pdfUrl = "/Alif_Hakimi_Resume.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Alif_Hakimi_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="mt-16 sm:mt-20 md:mt-24 px-4 sm:px-6 md:px-0">
      <div
        onClick={() => navigate("/about")}
        className="flex flex-col items-center"
      >
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2">
          <div class="relative p-6 sm:p-10 md:p-16 col-span-1 lg:col-span-3 lg:row-span-2 flex flex-col lg:flex-row items-center bg-gray-50 rounded-2xl m-2 overflow-hidden hover:bg-gray-100">
            <div class="flex flex-col gap-y-4 text-left w-full lg:w-3/6">
              <h1 class="text-2xl sm:text-3xl md:text-4xl font-semibold">About me</h1>
              <p class="text-sm sm:text-base font-normal text-gray-500 mt-2 md:mt-4">
                My name is Alif Hakimi, and I am a student in computer science
                at National University of Malaysia (UKM). I love creating
                solutions using softwares and making real-life impacts with
                technology.
              </p>
              <div className="relative z-10 text-black flex flex-col items-start rounded-xl w-36 sm:w-40 bg-white r shadow-lg shadow-sky-500">
                <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                <button
                  onClick={handleDownloadResume}
                  class="relative gradient-border px-3 py-2 sm:px-4 sm:py-2 rounded-xl flex items-center justify-between bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white w-full text-sm sm:text-base font-normal transform hover:scale-105 duration-300"
                >
                  <FaDownload />
                  My resume
                </button>
              </div>
            </div>
            <img
              src="assets/profile_pic.jpeg"
              className="rounded-lg w-full max-w-xs lg:max-w-sm mt-6 lg:mt-0 lg:ml-3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
